module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-menu"
  }, [_c('div', {
    staticClass: "searchbar"
  }, [(!_vm.$store.state.searching) ? _c('form', {
    staticClass: "animated fadeIn",
    attrs: {
      "action": "."
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.doSearch()
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.licenseplate),
      expression: "$store.state.licenseplate"
    }],
    staticClass: "hero-search",
    attrs: {
      "type": "search",
      "placeholder": "AL 52 114",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.$store.state.licenseplate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state, "licenseplate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.$store.state.match) ? _c('div', {
    staticClass: "vehicle-header animated zoomIn"
  }, [_c('div', {
    staticClass: "make-model"
  }, [_vm._v("\n                    " + _vm._s(_vm.$store.state.carData.general.MaerkeTypeNavn) + "\n                    "), (_vm.$store.state.carData.general.ModelTypeNavn !== 'UOPLYST' && _vm.$store.state.carData.general.ModelTypeNavn !== '-') ? _c('span', [_vm._v("\n                        " + _vm._s(_vm.$store.state.carData.general.ModelTypeNavn) + "\n                    ")]) : _vm._e()]), _vm._v(" "), (_vm.$store.state.carData.general.VariantTypeNavn !== 'UOPLYST' && _vm.$store.state.carData.general.VariantTypeNavn !== '-') ? _c('div', {
    staticClass: "variant"
  }, [_c('span', [_vm._v("\n                        " + _vm._s(_vm.$store.state.carData.general.VariantTypeNavn) + "\n                    ")]), _vm._v(" "), (_vm.$store.state.carData.general.KarrosseriTypeNavn && _vm.$store.state.carData.general.KarrosseriTypeNavn !== 'Hatchback') ? _c('span', [_vm._v("\n                        (" + _vm._s(_vm.$store.state.carData.general.KarrosseriTypeNavn) + ")\n                    ")]) : _vm._e()]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.$store.state.searching) ? _c('div', {
    staticClass: "spinner-loader"
  }, [_vm._m(0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "container menu-container"
  }, [_c('div', {
    staticClass: "menu-wrapper"
  }, _vm._l((_vm.menuItems), function(item) {
    return _c('router-link', {
      key: item.slug,
      staticClass: "menu-item",
      class: {
        'active': item.slug === _vm.activeMenuItem
      },
      attrs: {
        "tag": "div",
        "to": {
          name: item.link
        }
      },
      on: {
        "click": function($event) {
          _vm.activeMenuItem = item.slug
        }
      }
    }, [_c('i', {
      class: 'fal fa-' + item.icon + ' fa-fw'
    }), _vm._v("\n                " + _vm._s(item.name) + "\n            ")])
  }), 1)]), _vm._v(" "), _c('div', {
    staticClass: "mobile-menu"
  }, _vm._l((_vm.menuItems), function(item) {
    return _c('router-link', {
      key: item.slug,
      staticClass: "menu-item",
      class: {
        'active': item.slug === _vm.activeMenuItem
      },
      attrs: {
        "tag": "div",
        "to": {
          name: item.link
        }
      },
      on: {
        "click": function($event) {
          _vm.activeMenuItem = item.slug
        }
      },
      nativeOn: {
        "click": function($event) {
          return _vm.$scrollToTop($event)
        }
      }
    }, [_c('div', {
      staticClass: "inner"
    }, [_c('i', {
      class: 'fal fa-' + item.icon + ' fa-fw'
    }), _vm._v(" "), _c('br'), _vm._v("\n                " + _vm._s(item.name) + "\n            ")])])
  }), 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader-wrapper"
  }, [_c('div', {
    staticClass: "lds-ring"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04d0111a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/search/components/topmenu.vue
// module id = 345
// module chunks = 1